export class User {
  ID: number;
  UserName: string;
  DNI: string;
  Direccion: string;
  Telefono: string;
  Correo: string;
  FechaNac: string;
  FechaIng: string;
  Password: string;
  FotoRuta: string;
  Description: string;
  Status: boolean;
  StatusName: string;
  SystemPersonID: string;
  UserCreation: string;
  DateCreation: string;
  UserLastUpdate: string;
  DateLastUpdate: string;
  claseArchivo: string;
  UserShortName: string;
  imagenReverso: string;
  seguimiento: boolean;
  seguimientoName: string;
  editarToken: boolean;
  multipleSesion: boolean;
  seguimientoUbicacion: boolean;
  autonomia: boolean;
}